import { ButtonStyle } from '../../../../../../../../buttons/ButtonComponent/model.js';

var ShiftCancelationStepName;
(function (ShiftCancelationStepName) {
    /**
     * Step 1 (if < 24 hours before visit & one draft waypoint)
     *
     * First step in the nurse cancelation flow if there is only one draft
     * waypoint and the shift is less than 24 hours away. In this flow, we allow
     * the nurse to either reschedule (with patient) or cancel the draft waypoint.
     */
    ShiftCancelationStepName["SELECT_REASON"] = "selectReason";
    /**
     * Step 2 (if < 24 hours before visit & one draft waypoint)
     *
     * Here, the nurse can either choose to cancel or reschedule the visit with
     * the patient.
     */
    ShiftCancelationStepName["PICK_OPTION"] = "pickOption";
    /**
     * Step 3 (if < 24 hours before visit & one draft waypoint)
     *
     * This step is the third and final step in the nurse cancelation flow. In
     * this step, the nurse can call the patient and cancel the shift.
     */
    ShiftCancelationStepName["CALL_CONTACT_AND_CANCEL"] = "callContactAndCancel";
    /**
     * Step 1 (if > 24 hours before visit or multiple draft waypoints)
     *
     * The first and last step in the nurse cancelation flow if there are multiple
     * draft waypoints or the shift is more than 24 hours away. Here, the nurse
     * picks a reason for canceling the shift and confirms the cancelation.
     */
    ShiftCancelationStepName["SELECT_REASON_AND_CANCEL"] = "selectReasonAndCancel";
})(ShiftCancelationStepName || (ShiftCancelationStepName = {}));
const shiftCancelationSteps = [
    {
        id: ShiftCancelationStepName.SELECT_REASON,
        title: 'Select a reason',
        subtitle: null,
        buttonText: 'Confirm',
        buttonStyle: ButtonStyle.PRIMARY,
        nextStep: ShiftCancelationStepName.PICK_OPTION,
    },
    {
        id: ShiftCancelationStepName.PICK_OPTION,
        title: 'Pick an option',
        subtitle: 'This job is less than 24 hours away. Please try to reschedule '
            + 'with the patient.',
        buttonText: 'Cancel shift',
        buttonStyle: ButtonStyle.OUTLINE_DANGER,
        /**
         * This next step is only used if the nurse chooses to cancel the shift.
         * Otherwise, the nurse enters the scheduling flow to reschedule the visit.
         */
        nextStep: ShiftCancelationStepName.CALL_CONTACT_AND_CANCEL,
    },
    {
        id: ShiftCancelationStepName.CALL_CONTACT_AND_CANCEL,
        title: 'Cancel shift',
        subtitle: null,
        buttonText: 'Cancel shift',
        buttonStyle: ButtonStyle.DANGER,
        nextStep: null,
    },
    {
        id: ShiftCancelationStepName.SELECT_REASON_AND_CANCEL,
        title: 'Select a reason',
        subtitle: null,
        buttonText: 'Cancel shift',
        buttonStyle: ButtonStyle.DANGER,
        nextStep: null,
    },
];
/** Get the first step in the nurse cancelation flow */
const getFirstStep = (draftWaypointIDs, hoursBeforeJob) => {
    if (draftWaypointIDs.length === 1 && hoursBeforeJob < 24) {
        return ShiftCancelationStepName.SELECT_REASON;
    }
    return ShiftCancelationStepName.SELECT_REASON_AND_CANCEL;
};
/** Get the next step in the nurse cancelation flow */
const getNextStep = (step) => { var _a, _b; return (_b = (_a = shiftCancelationSteps.find((s) => s.id === step)) === null || _a === void 0 ? void 0 : _a.nextStep) !== null && _b !== void 0 ? _b : null; };

export { ShiftCancelationStepName, getFirstStep, getNextStep, shiftCancelationSteps };
